module.exports = __webpack_public_path__ + "static/media/tv.e92aeb54.svg";